import * as reactIntl from 'react-intl';

import { yup } from '»utils/form';

import { createAccountCommonValidation } from '../../CreateAccount.yup.common';

export const createStinvestValidation = ({ mustAllowDataProcessing }) => {
  const intl = reactIntl.useIntl();

  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  const ibanFormatValidation = intl.formatMessage({
    id: 'TRLT_UI-IBAN_FORMAT_VALIDATION',
  });

  const angolanIbanFormatValidation = intl.formatMessage({
    id: 'TRLT_UI-ANGOLAN_IBAN_FORMAT_VALIDATION',
  });

  const ibanMustBeDifferent = intl.formatMessage({
    id: 'TRLT_UI-IBAN_MUST_BE_DIFFERENT',
  });

  return yup.object().shape({
    ...createAccountCommonValidation({ mustAllowDataProcessing }),
    idType: yup.string().required(requiredFieldMessage),
    idNumber: yup.string().required(requiredFieldMessage),
    bankCode: yup.string().required(requiredFieldMessage),
    ibanCode: yup
      .string()
      .ibanAo06FormatValidation(angolanIbanFormatValidation)
      .required(requiredFieldMessage),
    ibanCode2: yup
      .string()
      .ibanAoFormatValidation(ibanFormatValidation)
      .differentFromField('ibanCode', ibanMustBeDifferent),
    email1: yup.string().required(requiredFieldMessage),
  });
};
